
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5358',
  depVersions: {
  "data-privacy-request-ui": "static-1.5358",
  "data-fetching-client": "static-1.9511",
  "head-dlb": "static-1.4841",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7840",
  "hub-http-shared-msw-handlers": "static-1.9554",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11274",
  "I18n": "static-7.1580",
  "jasmine-runner": "static-1.6304",
  "privacy-center-public-service-types": "static-1.4621",
  "quartz": "static-1.6777",
  "react-dlb": "static-1.73",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5412",
  "UIComponents": "static-3.8221",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.82",
  "foundations-assets": "static-1.4673",
  "foundations-components": "static-1-jhardy-popover-allow-cross-axis-shift.13",
  "foundations-components-test-utils": "static-1-jhardy-popover-allow-cross-axis-shift.13",
  "foundations-theming": "static-1.4244",
  "hub-http": "static-1.6052",
  "quartz-config": "static-1.555",
  "quartz-core": "static-1.5996",
  "quick-fetch": "static-1.3770",
  "raven": "static-3.5725",
  "react": "static-7.180",
  "react-rhumb": "static-1.16484",
  "SharedI18nStrings": "static-1.180",
  "ui-addon-i18n": "static-1.10978",
  "usage-tracker": "static-1.7169",
  "usage-tracker-anonymous": "static-1.5586",
  "usage-tracker-core": "static-1.7019",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3957",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3262",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3054",
  "quartz-webpack": "static-1.3001",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.78",
  "HeadJS": "static-2.718",
  "framer-motion": "static-1.68",
  "hs-test-utils-bend-plugin": "static-1.2951",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "ts-schema": "static-1.3938",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "react-utils": "static-2.5207",
  "StyleGuideUI": "static-3.484",
  "jasmine": "static-4.4160",
  "rpc-client-utils": "static-1.4471",
  "HubStyle": "static-2.11582",
  "ui-addon-draggable": "static-3.4600",
  "cssUtils": "static-1.744",
  "hs-story-utils": "static-1.9260",
  "icons": "static-2.626",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.95",
  "ui-images": "static-2.1106",
  "bend-plugin-foundations-components": "static-1-jhardy-popover-allow-cross-axis-shift.13",
  "floating-ui": "static-1.52",
  "foundations-theming-specialty": "static-1.1960",
  "react-aria": "static-1.62",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1308",
  "ui-fonts": "static-1.536",
  "foundations-components-legacy": "static-1-jhardy-popover-allow-cross-axis-shift.13",
  "bend-plugin-foundations-theming": "static-1.2727",
  "foundations-theming-base": "static-1.3229",
  "stylex": "static-1.28",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.803",
  "hubspotter-http": "static-1.4511",
  "mobile-manifest-mixins": "static-1.491",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.452",
  "quartz-head": "static-1.442",
  "quartz-i18n": "static-1.452",
  "quartz-routing": "static-1.207",
  "quartz-test": "static-1.452",
  "quartz-tracking": "static-1.156",
  "usage-tracker-container": "static-1.7159",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.2982",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.66",
  "sassPrefix": "static-1.152",
  "hubspotter-http-shared-msw-handlers": "static-1.9552"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5358",
  "data-fetching-client": "/data-fetching-client/static-1.9511",
  "head-dlb": "/head-dlb/static-1.4841",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7840",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9554",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11274",
  "I18n": "/I18n/static-7.1580",
  "jasmine-runner": "/jasmine-runner/static-1.6304",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4621",
  "quartz": "/quartz/static-1.6777",
  "react-dlb": "/react-dlb/static-1.73",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5412",
  "UIComponents": "/UIComponents/static-3.8221",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
  "foundations-assets": "/foundations-assets/static-1.4673",
  "foundations-components": "/foundations-components/static-1-jhardy-popover-allow-cross-axis-shift.13",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-jhardy-popover-allow-cross-axis-shift.13",
  "foundations-theming": "/foundations-theming/static-1.4244",
  "hub-http": "/hub-http/static-1.6052",
  "quartz-config": "/quartz-config/static-1.555",
  "quartz-core": "/quartz-core/static-1.5996",
  "quick-fetch": "/quick-fetch/static-1.3770",
  "raven": "/raven/static-3.5725",
  "react": "/react/static-7.180",
  "react-rhumb": "/react-rhumb/static-1.16484",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10978",
  "usage-tracker": "/usage-tracker/static-1.7169",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5586",
  "usage-tracker-core": "/usage-tracker-core/static-1.7019",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3262",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3054",
  "quartz-webpack": "/quartz-webpack/static-1.3001",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.78",
  "HeadJS": "/HeadJS/static-2.718",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2951",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "ts-schema": "/ts-schema/static-1.3938",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "react-utils": "/react-utils/static-2.5207",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "jasmine": "/jasmine/static-4.4160",
  "rpc-client-utils": "/rpc-client-utils/static-1.4471",
  "HubStyle": "/HubStyle/static-2.11582",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4600",
  "cssUtils": "/cssUtils/static-1.744",
  "hs-story-utils": "/hs-story-utils/static-1.9260",
  "icons": "/icons/static-2.626",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.95",
  "ui-images": "/ui-images/static-2.1106",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-jhardy-popover-allow-cross-axis-shift.13",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1960",
  "react-aria": "/react-aria/static-1.62",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1308",
  "ui-fonts": "/ui-fonts/static-1.536",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-jhardy-popover-allow-cross-axis-shift.13",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2727",
  "foundations-theming-base": "/foundations-theming-base/static-1.3229",
  "stylex": "/stylex/static-1.28",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.803",
  "hubspotter-http": "/hubspotter-http/static-1.4511",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.491",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.452",
  "quartz-head": "/quartz-head/static-1.442",
  "quartz-i18n": "/quartz-i18n/static-1.452",
  "quartz-routing": "/quartz-routing/static-1.207",
  "quartz-test": "/quartz-test/static-1.452",
  "quartz-tracking": "/quartz-tracking/static-1.156",
  "usage-tracker-container": "/usage-tracker-container/static-1.7159",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.2982",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.66",
  "sassPrefix": "/sassPrefix/static-1.152",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9552"
}
};
